module.exports = __webpack_public_path__ + "static/media/lemoncash.ea67d7c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/StandAlone/lemoncash.svg
// module id = 332
// module chunks = 0